import { create } from 'zustand';
import { DateRange } from 'react-day-picker';
import { ColumnState } from 'ag-grid-community';
import { defaultSYS4120_R01Dto, SYS4120_R01Dto } from './Dto_SYS4120_R01';
import { allCd, useCommonCodeStore } from 'src/store/useCommonCodeStore';
import { getFutureWeekday, getFutureWeekdayExceptTodayAndTomorrow } from 'src/utils/date/dateUtils';
import { formatDate } from 'src/utils/string/stringUtil';

export interface SYS4120_R01Filter {
	dateRange: DateRange | undefined;
	topNotice: string;
}

export interface Store_SYS4120_R01 {
	SYS4120_R01Filter: SYS4120_R01Filter;
	SYS4120_R01PastFilter: SYS4120_R01Filter;
	setSYS4120_R01Filter: (filter: Partial<SYS4120_R01Filter>) => void;
	setSYS4120_R01PastFilter: (filter: Partial<SYS4120_R01Filter>) => void;

	SYS4120_R01List: SYS4120_R01Dto[];
	setSYS4120_R01List: (SYS4120_R01List: SYS4120_R01Dto[]) => void;

	selectedSYS4120_R01: SYS4120_R01Dto | undefined;
	setSelectedSYS4120_R01: (item: SYS4120_R01Dto | undefined) => void;
	initSelectedSYS4120_R01: () => void;

	editSYS4120_R01: SYS4120_R01Dto | null;
	setEditSYS4120_R01: (item: SYS4120_R01Dto | null) => void;

	columnState: ColumnState[] | null;
	setColumnState: (state: ColumnState[] | null) => void;

	scrollTop: number | null;
	setScrollTop: (top: number | null) => void;

	allCount: number;				setAllCount: (allCount: number) => void;

	initData: () => void;
}

export const defaultSYS4120_R01Filter : SYS4120_R01Filter = {
	dateRange: {
		from: new Date(new Date().getFullYear(), new Date().getMonth(), 1),
		to: new Date()
	},
	topNotice: '',
};

export const useSYS4120_R01Store = create<Store_SYS4120_R01>((set) => ({
	SYS4120_R01Filter: defaultSYS4120_R01Filter,
	SYS4120_R01PastFilter: defaultSYS4120_R01Filter,
	setSYS4120_R01Filter: (filter: Partial<SYS4120_R01Filter>) => set((state) =>  ({
		...state,
		SYS4120_R01Filter: {
			...state.SYS4120_R01Filter,
			...filter
		}	
	})),
	setSYS4120_R01PastFilter: (filter: Partial<SYS4120_R01Filter>) => set((state) =>  ({
		...state,
		SYS4120_R01PastFilter: {
			...state.SYS4120_R01PastFilter,
			...filter
		}	
	})),

	SYS4120_R01List: [],
	setSYS4120_R01List: (SYS4120_R01List: SYS4120_R01Dto[]) => set({ SYS4120_R01List }),

	selectedSYS4120_R01: undefined,
	setSelectedSYS4120_R01: (item: SYS4120_R01Dto | undefined) => set((state) => {

		return { ...state, selectedSYS4120_R01: item };
	}),
	initSelectedSYS4120_R01: () => set({ selectedSYS4120_R01: undefined, editSYS4120_R01: defaultSYS4120_R01Dto }),
	
	editSYS4120_R01: defaultSYS4120_R01Dto,
	setEditSYS4120_R01: (item: SYS4120_R01Dto | null) => set((state) => {
		let editData = defaultSYS4120_R01Dto;
		if (item) {
			editData = { ...item,
				noticeDateRange: {
					from: item.noticeFromDt ? new Date(formatDate(item.noticeFromDt)) : new Date(),
					to: item.noticeEndDt ? new Date(formatDate(item.noticeEndDt)) : new Date(),
				},
			};
		}
		return { editSYS4120_R01: editData };
	}),

	columnState: null,
	setColumnState: (state: ColumnState[] | null) => set({ columnState: state }),

	scrollTop: null,
	setScrollTop: (top: number | null) => set({ scrollTop: top }),

	allCount: 0,
	setAllCount: (allCount: number) => set({ allCount }),

	initData: () => set((state) => ({
		...state,
		SYS4120_R01Filter: defaultSYS4120_R01Filter,
		SYS4120_R01PastFilter: defaultSYS4120_R01Filter,
		selectedSYS4120_R01: undefined,
		editSYS4120_R01: defaultSYS4120_R01Dto,
		SYS4120_R01List: [],
		allCount: 0,
		scrollTop: null,
	})),

	
}));
